module.exports = __webpack_public_path__ + "static/media/facebook.34af6a9b.svg";